"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BadgeModule = _interopRequireDefault(require("./Badge.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Badge = _ref => {
  var className = _ref.className,
    content = _ref.content,
    variant = _ref.variant,
    type = _ref.type;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_BadgeModule.default.Badge, className),
    "data-variant": variant,
    "data-content-type": type
  }, type === 'number' && Number(content) > 9 ? '9+' : content);
};
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map